import * as cursor from './cursor.js';

export default (node) => {
	const play = node.querySelector('.js-play');
	const timeline = node.querySelector('.js-timeline');
	const duration = node.querySelector('.js-duration');
	const fullscreen = node.querySelector('.js-fullscreen');
	const actions = node.querySelector('.js-actions');
	var script = document.querySelector('#script-yt');
	
	if (!script) {
		// youtube
		var tag = document.createElement('script');
		tag.src = "https://www.youtube.com/iframe_api";
		tag.id = "script-yt";
		var firstScriptTag = document.getElementsByTagName('script')[0];
		firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
	}

	const evt = new CustomEvent('yt_ready', {});
	document.addEventListener('yt_ready', () => {
		init();
	}, { once: true });

	if (window.YT) {
		document.dispatchEvent(evt);
	} else {
		window.onYouTubePlayerAPIReady = function() {
			document.dispatchEvent(evt);
		}
	}

	function init() {

		const player = node.querySelector('.player');
		const id = player.getAttribute('data-id');
		const iframe = player.querySelector('.iframe');

		const play_text = node.dataset.textPlay;
		const pause_text = node.dataset.textPause;

		var timer;

		const yt_player = new YT.Player(iframe, {
			height: '100%',
			width: '100%',
			videoId: id,
			playerVars: {
				'modestbranding': 1,
				'controls': 0,
				'rel': 0,
				'showinfo': 0
			},

			events: {
				onStateChange: (e) => {
					if (e.data == YT.PlayerState.ENDED || e.data == YT.PlayerState.PAUSED) {
						clearInterval(timer);
						node.classList.remove('active');
						timeline.style.setProperty('--timeline', '0%');
					} else if (e.data == YT.PlayerState.PLAYING) {
						node.classList.add('active');
						timer = setInterval(function () {
							const total = Math.ceil(yt_player.getDuration());
							const time = Math.ceil(yt_player.getCurrentTime());
							const difference = (time / total) * 100;
							timeline.style.setProperty('--timeline', difference + '%');
							duration.innerHTML = convert_time(time) + ' / ' + convert_time(total);
						}, 100);
					}

				}
			}
		});

		timeline.addEventListener('click', (e) => {
			const rect = timeline.getBoundingClientRect();
			const offset_x = rect.left;
			const w = rect.width;
			const x = e.x;
			const diff = x - offset_x;
			const percent = diff * 100 / w;

			timeline.style.setProperty('--timeline', percent + '%');

			const total = yt_player.getDuration();
			const time = total * percent / 100;

			clearInterval(timer);
			yt_player.seekTo(time, true);
			yt_player.playVideo();

		});

		if (fullscreen) {
			fullscreen.addEventListener('click', () => {
				const el = node.querySelector('iframe');
				var requestFullScreen = el.requestFullScreen || el.mozRequestFullScreen || el.webkitRequestFullScreen;
				if (requestFullScreen) {
					requestFullScreen.bind(el)();
				}
			})
		}

		node.addEventListener('click', (e) => {

			let target = e.target;

			do {
			    if (target == actions) {
			        return;
			    }

			    target = target.parentNode;

			} while (target);

			if (yt_player.getPlayerState() == YT.PlayerState.PLAYING) {
				yt_player.pauseVideo();
				return;
			}

			yt_player.playVideo();
			
		});

		if (play) {
			play.addEventListener('click', (e) => {
				if (yt_player.getPlayerState() == YT.PlayerState.PLAYING) {
					yt_player.pauseVideo();
					return;
				}

				yt_player.playVideo();
			});
		}

		var delay = false;
		var on = false;

		node.addEventListener('mousemove', function(e){
			// controls(delay, on);

			if (on === false) {
				on = true;
				node.classList.add('controls');
			}

			clearTimeout(delay);
			delay = setTimeout(function(e){
				node.classList.remove('controls');
				on = false;
			}, 3000);

		});

		function convert_time(s){return(s-(s%=60))/60+(9<s?':':':0')+s}

	}
};